import baseApi from "@/api/baseApi";
export default {
  fetch() {
    return baseApi.get('api-reporting/api/v1/report');
  },
  fetchById(id) {
    return baseApi.get(`api-reporting/api/v1/report/${id}`);
  },
  fetchMetadata(id) {
    return baseApi.get(`api-reporting/api/v1/report-metadata/${id}`);
  },
  fetchMenuOptions() {
    return baseApi.get(`api-reporting/api/v1/report-menu-position/options`);
  },
  fetchMenuPositions(id) {
    return baseApi.get(`api-reporting/api/v1/report-menu-position/${id}`);
  },
  fetchLinks() {
    return baseApi.get(`api-reporting/api/v1/report-menu-position`);
  },
  upsertMetadata(form) {
    return baseApi.post(`api-reporting/api/v1/report-metadata`, form);
  },
  upsertMenuPositions(id, form) {
    return baseApi.post(`api-reporting/api/v1/report-menu-position/${id}`, form);
  },
  saveForPreview(id, data) {
    return baseApi.post(`api-reporting/api/v1/report-data-value/save-for-preview/${id}`, data);
  },
  prepareForExport(data) {
    return baseApi.put(`api-reporting/api/v1/report-request`, data);
  },
  multiPrepareForExport(data) {
    return baseApi.put(`api-reporting/api/v1/report-request/multi-prepare`, data);
  }
}
